// removed by extract-text-webpack-plugin
module.exports = {"nav-item":"Navigation__nav-item___1jPHu","active":"Navigation__active___37SVT","nav":"Navigation__nav___3Pm9p"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Navigation.scss
// module id = 183
// module chunks = 0